import {Moment} from 'moment-timezone'

export const getLeftAlignedHourListFromRange = (startDate: Moment, endDate: Moment): Moment[] => {
  const hoursList: Moment[] = []
  let now = startDate.clone()

  while (now.isBefore(endDate)) {
    hoursList.push(now)
    now = now.clone().add(1, 'hours')
  }
  return hoursList
}
